/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Action_Bar_Waiting_Toss_NeededInputs */



/**
* | output |
* | --- |
* | "Round {n} complete. Resolve top 5 ties with a toss before starting finals." |
*
* @param {Action_Bar_Waiting_Toss_NeededInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const action_bar_waiting_toss_needed = /** @type {((inputs: Action_Bar_Waiting_Toss_NeededInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Bar_Waiting_Toss_NeededInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ronde ${i?.n} terminée. Résolvez les égalités du top 5 par tirage au sort avant de lancer la finale.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ronda ${i?.n} completada. Resuelva los empates del top 5 con un sorteo antes de iniciar la final.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Rodada ${i?.n} completa. Resolva os empates do top 5 com um sorteio antes de iniciar a final.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Round ${i?.n} completato. Risolvi i pareggi del top 5 con un sorteggio prima di avviare la finale.`)
	return /** @type {LocalizedString} */ (`Round ${i?.n} complete. Resolve top 5 ties with a toss before starting finals.`)
});